module.exports = __webpack_public_path__ + "static/media/landingpage_cpg.39ea7c70.png";